/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Load_FailedInputs */

const vi_media_load_failed = /** @type {(inputs: Media_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được thư viện ảnh. Hãy tải lại trang.`)
};

/**

* @param {Media_Load_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_load_failed = /** @type {((inputs?: Media_Load_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Load_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_load_failed(inputs)
});